import React, { useState, useEffect, useContext } from "react";
import classes from "./MonthlyExpenditure.module.css";
import { Row, Col, Form, Card, Button, Table } from "react-bootstrap";
import PermissionContext from "../../../Store/permission-context";
import DatePicker, {
  DateObject,
  getAllDatesInRange,
} from "react-multi-date-picker";
import ProcessingModal from "../Modals/ProcessingModal";
const MonthlyExpenditure = () => {
  const [SingleDate, setSingleDate] = useState("");
  const [Dates, setDates] = useState("");
  const [AllPurposes, setAllPurposes] = useState([]);
  const [DisplayTab, setDisplayTab] = useState(false);
  const [disableButton, setdisableButton] = useState(true);
  const [ShowProcessing, setShowProcessing] = useState(false);
  const PCtx = useContext(PermissionContext);
  useEffect(() => {
    // if (AllDates.length > 0) {
    if (Dates != "") {
      //   let AD = AllDates.map((d) => d.toString());
      let SD = Dates.toString();
      //   setDatesSelected(AD);
      setSingleDate(SD);
      setdisableButton(false);
    }
    // }
  }, [Dates]);

  const GetTheReport = async () => {
    setShowProcessing(true);
    let Summary = await PCtx.connectAxios("getexpensessummary.php", SingleDate);
    setAllPurposes(Summary);
    setShowProcessing(false);
  };

  return (
    <Row>
      <Card style={{ minHeight: "60px" }}>
        <Card.Body className="m-0 p-0">
          <Row className="justify-content-around align-items-center">
            <Col md={3} sm={12} xs={12} className="text-center">
              <p className={classes.please}>PLEASE PICK REPORT DATE</p>
            </Col>
            <Col
              md={3}
              sm={12}
              xs={12}
              className="mt-1"
              style={{ paddingLeft: "120px" }}
            >
              <h6 className="h6">
                Just pick any day in the desired month and year when the
                carlendar opens, then click Generate Report
              </h6>
            </Col>
            <Col md={3} sm={12} xs={12} className="text-center">
              <label className={classes.labelradio}>
                Please pick a date
                <br />
                <DatePicker
                  value={Dates}
                  editable={false}
                  style={{ border: "1px solid brown", height: "30px" }}
                  placeholder="Click me to open calendar!"
                  onChange={(dateObjects) => {
                    setDisplayTab(false);
                    setdisableButton(false);
                    setDates(dateObjects);
                  }}
                  format="MMM, YYYY"
                  //   format="MMM DD, YYYY"
                  //   range={DateCategory === "range" ? true : false}
                  shadow={true}
                />
              </label>
            </Col>
            <Col
              md={3}
              sm={12}
              xs={12}
              className="align-self-center text-center"
            >
              <Button
                variant="info"
                onClick={GetTheReport}
                disabled={disableButton}
                style={{ backgroundColor: "brown", color: "white" }}
              >
                Generate Report
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <Card>
        <Card.Body>
          <Row className="justify-content-around">
            <Col md={10} lg={10} xs={11} sm={11}>
              <h3 className="h3 text-center">Total Expenses in {SingleDate}</h3>
              <Table responsive bordered stripped>
                <thead>
                  <tr>
                    <th>SN</th>
                    <th>Description</th>
                    <th>Amount Spent</th>
                  </tr>
                </thead>
                <tbody>
                  {AllPurposes.map((pup, index) => (
                    <tr>
                      <td
                        className={
                          index === AllPurposes.length - 1
                            ? classes.TotalRow
                            : classes.NonTotalRow
                        }
                      >
                        {index === AllPurposes.length - 1 ? "" : index + 1}
                      </td>
                      <td
                        className={
                          index === AllPurposes.length - 1
                            ? classes.TotalRow
                            : classes.NonTotalRow
                        }
                      >
                        {pup.Purpose}
                      </td>
                      <td
                        className={
                          index === AllPurposes.length - 1
                            ? classes.TotalRow
                            : classes.NonTotalRow
                        }
                      >
                        ₦{pup.Amount}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      {ShowProcessing && <ProcessingModal Show={ShowProcessing} />}
    </Row>
  );
};

export default MonthlyExpenditure;
